import { PASSWORD } from "../../../constants/fields";
import { FieldConfig } from "../../common/forms/Interfaces";

const config = {
  old_password: {
    type: PASSWORD,
    label: "Old Password",
    placeholder: "Enter old password",
    validationRules: [
      { required: true, message: "Please input old password!" },
      { min: 6, message: "The field must be at least 6 characters!" },
    ],
  },
  password: {
    type: PASSWORD,
    label: "New Password",
    placeholder: "Enter new password",
    validationRules: [
      { required: true, message: "Please input old password!" },
      { min: 6, message: "The field must be at least 6 characters!" },
    ],
  },
  password_confirmation: {
    type: PASSWORD,
    label: "Repeat Password",
    placeholder: "Repeat new password",
    validationRules: [
      { required: true, message: "Please input old password!" },
      { min: 6, message: "The field must be at least 6 characters!" },
      ({ getFieldValue }) => ({
        validator(rule, value) {
          if (!value || getFieldValue("password") === value) {
            return Promise.resolve();
          }

          return Promise.reject(
            "The two passwords that you entered do not match!"
          );
        },
      }),
    ],
  },
} as { [key: string]: FieldConfig };

export default config;
